var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup37(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 14,
    viewBox: "0 0 381 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.199 7.13911C332.195 5.77246 338.93 8.33492 287.58 3.85062C213.991 -1.74407 217.788 18.9264 181.445 9.18906C152.47 1.33087 148.493 -2.72635 118.252 5.60162C91.1309 14.2285 90.7693 16.6629 25 5.5162",
    stroke: "url(#paint0_linear_53_254)",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.199 7.13911C308.195 5.77246 314.93 8.33492 263.58 3.85062C189.991 -1.74407 193.788 18.9264 157.445 9.18906C128.47 1.33087 124.493 -2.72635 94.2523 5.60162C67.1309 14.2285 66.7693 16.6629 0.999999 5.5162",
    stroke: "url(#paint1_linear_53_254)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_254",
    x1: 380.199,
    y1: 7,
    x2: 25,
    y2: 6.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512971,
    stopColor: "#00FDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403C4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_254",
    x1: 356.199,
    y1: 7,
    x2: 1,
    y2: 6.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512971,
    stopColor: "#00FDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403C4F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37);
export default __webpack_public_path__ + "static/media/Group37.bee3bdb02bd0ec8885c783068378f760.svg";
export { ForwardRef as ReactComponent };